import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import LeftHeading from '../../../../Components/Accounts/LeftHeading/LeftHeading'
import PaymentContainer from '../../../../Components/Accounts/Payments/PaymentContainer/PaymentContainer'
import PaymentMethodeManage from '../../../../Components/Accounts/Payments/PaymentMethodeManage/PaymentMethodeManage'
import PaymentTabs from '../../../../Components/Accounts/Payments/PaymentTabs/PaymentTabs'
import Tranjection from '../../../../Components/Accounts/Payments/Tranjection/Tranjection'
import TranjectionTab from '../../../../Components/Accounts/Payments/TranjectionTab/TranjectionTab'
import Section from '../../../../Components/Section/Section'
import { PaymentRedioGroup } from '../../../../Components/Accounts/Payments/PaymentRedioGroup/PaymentRedioGroup'
import './../../../../Components/Accounts/Payments/radiobutton.css'
import PaymentFormBox from '../../../../Components/Accounts/Payments/PaymentFormBox/PaymentFormBox'
import PaymentMethodBox from '../../../../Components/Accounts/Payments/PaymentMethodBox/PaymentMethodBox'
import { useEffect } from 'react'
import SupplierPaymentApi from '../../../../Api/SupplierPaymentApi'
import { getResponseError, getUserDetailsCookie } from '../../../../Api/Utils/apiUtils'
import BusinessDetailsApi from '../../../../Api/BusinessDetailsApi'
import ErrorAlert from '../../../../Components/Form/ErrorAlert/ErrorAlert'
import { formContent } from "./content"
import { FormProvider, useForm } from 'react-hook-form'
import TextInput from '../../../../Components/Form/TextInput/TextInput'
import Button from '../../../../Components/Form/Button/Button'
import PaymentTypeCheckBox from '../../../../Components/Accounts/Payments/PaymentTypeCheckBox/PaymentTypeCheckBox'


const ManagePaymentComponent = () => {
    // content init
    const { 
        payID,
        EFTAccountName,
        EFTAccountNumber,
        eftBSB,
        updateButton,
        createButton
    } = formContent

    const [tabsActive, settabsActive] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null);
    const [paymentStatus, setpaymentStatus] = useState([])
    const [paymentMethods, setpaymentMethods] = useState({})
    const [isPayId, setisPayId] = useState(false)
    const [isEtfAccount, setisEtfAccount] = useState(true)
    const [paymentMethodId, setpaymentMethodId] = useState(true)
    const [paymentID, setpaymentID] = useState(null)
    const [supplierID, setsupplierID] = useState(null)

    function removeErrorMessage() {
        setTimeout(() => {
            setErrorMessage(null)
        }, 5000);
    }

    useEffect(() => {
        // ==> payment method and tranjection
        const loadPaymentMethodAndTranjection = async () => {
            const user = getUserDetailsCookie();
            const userId = user.id;
            const businessDetailsResponse = await BusinessDetailsApi.getBusinessDetails(userId);
            const businessApiError = getResponseError(businessDetailsResponse);
            if (businessApiError) {
                setErrorMessage(businessApiError);
                removeErrorMessage()
            }else{
                const supplierId = businessDetailsResponse.objectVal.userId;
                setsupplierID(supplierId)
                const response = await SupplierPaymentApi.getPaymentStatus(supplierId)
                const paymentStatusApiError = getResponseError(response)
                if (paymentStatusApiError) {
                    setErrorMessage(paymentStatusApiError)
                    removeErrorMessage()
                }else{
                    const paymentStatusList = response.objectVal
                    setpaymentStatus(paymentStatusList)
                }
                // payment methods
                const methods = await SupplierPaymentApi.getPaymentMethod(supplierId)
                const paymentMethodApiError = getResponseError(methods)
                if (paymentMethodApiError) {
                    setErrorMessage(paymentMethodApiError)
                    removeErrorMessage()
                }else{
                    const paymentMethodList = methods.objectVal
                    paymentMethodList.id && setpaymentMethodId(paymentMethodList.id)
                    setpaymentID(paymentMethodList.id)
                    setpaymentMethods(paymentMethodList)
                    setisPayId(paymentMethodList.isPayId)
                    setisEtfAccount(paymentMethodList.isEFT)
                }
            }
        }
        loadPaymentMethodAndTranjection()
    }, [])

    const formBinding = useForm();

    const { watch, handleSubmit } = formBinding;
    watch(() => setErrorMessage(''));

    // form on submit
    const submitForm = async (data) => {
        data.isPayId = isPayId
        data.isEFT = isEtfAccount
        if (paymentID) {
            // update payment method
            const response = await SupplierPaymentApi.updatePaymentMethod(paymentID, supplierID, isPayId, data.isEFT, data.payId, data.EFTAccountName, data.EFTAccountNumber, data.eftBSB)
            const responseApiError = getResponseError(response)
            if (responseApiError) {
                setErrorMessage(responseApiError)
                removeErrorMessage()
            }else{
                window.location.reload()
            }
        }else{
            // Add payment method 
            const response =  await SupplierPaymentApi.addPaymentMethod(supplierID, data.isPayId, data.isEFT, data.payID, data.EFTAccountName, data.EFTAccountNumber, data.EFTBSB)
            const responseApiError = getResponseError(response)
            if (responseApiError) {
                setErrorMessage(responseApiError)
                removeErrorMessage()
            }else{
                window.location.reload()
            }
        }

    }

    return (
        <Section>
            <Container>
                <LeftHeading>Manage Payments</LeftHeading>
                <PaymentContainer>
                    {/* Tabs button */}
                    <PaymentTabs>
                        <div className={!tabsActive ? "active" : ""} onClick={() => settabsActive(false)}>Payment Methods</div>
                        <div className={ tabsActive? " active" : ""} onClick={() => settabsActive(true)}>Payment status</div>
                    </PaymentTabs>
                    {tabsActive ?
                    <TranjectionTab>
                        <ErrorAlert>{errorMessage}</ErrorAlert>
                        {paymentStatus && paymentStatus.length > 0 && 
                        paymentStatus.map((status, index) => (
                            <Tranjection key={index} paymentId={status.paymentId} clientId={status.buyerId} paymentStatus={status.paymentStatus} purchaseId={status.purchaseId} ammount={status.amount} isPaid={status.isPaid} label={"Buyer"}  />
                        ))
                        }
                    </TranjectionTab>
                    :
                    <>
                    <PaymentMethodeManage>
                        <ErrorAlert>{errorMessage}</ErrorAlert>
                        <PaymentRedioGroup>
                            {/* if payment method is array remove bottom two div classnamecheckbokitem map the array with first item and set array element data */}
                            <PaymentTypeCheckBox isActive={isPayId} setActiveOrDeactive={setisPayId} label={`Pay ID`} />
                            <PaymentTypeCheckBox isActive={isEtfAccount} setActiveOrDeactive={setisEtfAccount} label={`EFT`} />
                        </PaymentRedioGroup>
                        <FormProvider {...formBinding}>
                        <form id="payment-form" onSubmit={handleSubmit(submitForm)}>
                            <PaymentFormBox methodData={paymentMethods}>
                                
                                {isPayId && 
                                <PaymentMethodBox>
                                    <h3>Pay Id</h3>
                                    <p></p>
                                    <TextInput {...payID} validation={isPayId && { required: `${payID.label} is required`}} />
                                </PaymentMethodBox>}
                                {isEtfAccount && 
                                <PaymentMethodBox>
                                    <h3>EFT Account</h3>
                                    <p></p>
                                    <TextInput {...EFTAccountName} validation={isEtfAccount && { required: `${EFTAccountName.label} is required`}} />
                                    <TextInput {...EFTAccountNumber} validation={isEtfAccount && { required: `${EFTAccountNumber.label} is required`}} />
                                    <TextInput {...eftBSB} width={135} validation={isEtfAccount && { required: `${eftBSB.label} is required`}} />
                                </PaymentMethodBox>}
                                <br />
                                {( isPayId || isEtfAccount) &&
                                paymentMethodId ?
                                <Button {...updateButton} />
                                :
                                <Button {...createButton} />}
                            </PaymentFormBox>
                        </form>
                        </FormProvider>
                    </PaymentMethodeManage>
                    </>
                    }
                </PaymentContainer>
            </Container>
        </Section>
    )
}

export default ManagePaymentComponent
